/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiLiveSessionCsvExportGet } from '../fn/live-session/api-live-session-csv-export-get';
import { ApiLiveSessionCsvExportGet$Params } from '../fn/live-session/api-live-session-csv-export-get';
import { apiLiveSessionGoogleCountParticipantsItemIdGet } from '../fn/live-session/api-live-session-google-count-participants-item-id-get';
import { ApiLiveSessionGoogleCountParticipantsItemIdGet$Params } from '../fn/live-session/api-live-session-google-count-participants-item-id-get';
import { apiLiveSessionGoogleCountParticipantsPost } from '../fn/live-session/api-live-session-google-count-participants-post';
import { ApiLiveSessionGoogleCountParticipantsPost$Params } from '../fn/live-session/api-live-session-google-count-participants-post';
import { apiLiveSessionItemIdActiveEnrolmentsGet } from '../fn/live-session/api-live-session-item-id-active-enrolments-get';
import { ApiLiveSessionItemIdActiveEnrolmentsGet$Params } from '../fn/live-session/api-live-session-item-id-active-enrolments-get';
import { apiLiveSessionItemIdDelete } from '../fn/live-session/api-live-session-item-id-delete';
import { ApiLiveSessionItemIdDelete$Params } from '../fn/live-session/api-live-session-item-id-delete';
import { apiLiveSessionItemIdGet } from '../fn/live-session/api-live-session-item-id-get';
import { ApiLiveSessionItemIdGet$Params } from '../fn/live-session/api-live-session-item-id-get';
import { apiLiveSessionItemIdGoogleRecordingGet } from '../fn/live-session/api-live-session-item-id-google-recording-get';
import { ApiLiveSessionItemIdGoogleRecordingGet$Params } from '../fn/live-session/api-live-session-item-id-google-recording-get';
import { apiLiveSessionOverviewGet } from '../fn/live-session/api-live-session-overview-get';
import { ApiLiveSessionOverviewGet$Params } from '../fn/live-session/api-live-session-overview-get';
import { apiLiveSessionPost } from '../fn/live-session/api-live-session-post';
import { ApiLiveSessionPost$Params } from '../fn/live-session/api-live-session-post';
import { apiLiveSessionUpdateRecordingsLinksPost } from '../fn/live-session/api-live-session-update-recordings-links-post';
import { ApiLiveSessionUpdateRecordingsLinksPost$Params } from '../fn/live-session/api-live-session-update-recordings-links-post';
import { Error } from '../models/error';
import { LiveSessionExportCsvFile } from '../models/live-session-export-csv-file';
import { LiveSessionItem } from '../models/live-session-item';
import { LiveSessionListActiveEnrolments } from '../models/live-session-list-active-enrolments';
import { LiveSessionMeetParticipantsCount } from '../models/live-session-meet-participants-count';
import { LiveSessionOverviewList } from '../models/live-session-overview-list';
import { LiveSessionUpsert } from '../models/live-session-upsert';


/**
 * Live Session service
 */
@Injectable({ providedIn: 'root' })
export class LiveSessionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiLiveSessionItemIdGet()` */
  static readonly ApiLiveSessionItemIdGetPath = '/api/live_session/{item_id}';

  /**
   * Get a live session.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionItemIdGet$Response(params: ApiLiveSessionItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionItem>> {
    return apiLiveSessionItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a live session.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionItemIdGet(params: ApiLiveSessionItemIdGet$Params, context?: HttpContext): Observable<LiveSessionItem> {
    return this.apiLiveSessionItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveSessionItem>): LiveSessionItem => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionItemIdDelete()` */
  static readonly ApiLiveSessionItemIdDeletePath = '/api/live_session/{item_id}';

  /**
   * Delete a live session and mark it as inactive in MyLXP if published.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionItemIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionItemIdDelete$Response(params: ApiLiveSessionItemIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiLiveSessionItemIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a live session and mark it as inactive in MyLXP if published.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionItemIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionItemIdDelete(params: ApiLiveSessionItemIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiLiveSessionItemIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionOverviewGet()` */
  static readonly ApiLiveSessionOverviewGetPath = '/api/live_session/overview';

  /**
   * Get live session overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionOverviewGet$Response(params?: ApiLiveSessionOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionOverviewList>> {
    return apiLiveSessionOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get live session overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionOverviewGet(params?: ApiLiveSessionOverviewGet$Params, context?: HttpContext): Observable<LiveSessionOverviewList> {
    return this.apiLiveSessionOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveSessionOverviewList>): LiveSessionOverviewList => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionPost()` */
  static readonly ApiLiveSessionPostPath = '/api/live_session';

  /**
   * Upsert a new live session.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiLiveSessionPost$Response(params: ApiLiveSessionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionUpsert>> {
    return apiLiveSessionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a new live session.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiLiveSessionPost(params: ApiLiveSessionPost$Params, context?: HttpContext): Observable<LiveSessionUpsert> {
    return this.apiLiveSessionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveSessionUpsert>): LiveSessionUpsert => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionItemIdActiveEnrolmentsGet()` */
  static readonly ApiLiveSessionItemIdActiveEnrolmentsGetPath = '/api/live_session/{item_id}/active-enrolments';

  /**
   * Get the number of active enrolments for a live session regarding each merchant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionItemIdActiveEnrolmentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionItemIdActiveEnrolmentsGet$Response(params: ApiLiveSessionItemIdActiveEnrolmentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionListActiveEnrolments>> {
    return apiLiveSessionItemIdActiveEnrolmentsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the number of active enrolments for a live session regarding each merchant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionItemIdActiveEnrolmentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionItemIdActiveEnrolmentsGet(params: ApiLiveSessionItemIdActiveEnrolmentsGet$Params, context?: HttpContext): Observable<LiveSessionListActiveEnrolments> {
    return this.apiLiveSessionItemIdActiveEnrolmentsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveSessionListActiveEnrolments>): LiveSessionListActiveEnrolments => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionItemIdGoogleRecordingGet()` */
  static readonly ApiLiveSessionItemIdGoogleRecordingGetPath = '/api/live_session/{item_id}/google-recording';

  /**
   * ATTENTION! This endpoint is only for internal purposes.
   * Get the recording link for a live session.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionItemIdGoogleRecordingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionItemIdGoogleRecordingGet$Response(params: ApiLiveSessionItemIdGoogleRecordingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Error>> {
    return apiLiveSessionItemIdGoogleRecordingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * ATTENTION! This endpoint is only for internal purposes.
   * Get the recording link for a live session.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionItemIdGoogleRecordingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionItemIdGoogleRecordingGet(params: ApiLiveSessionItemIdGoogleRecordingGet$Params, context?: HttpContext): Observable<Error> {
    return this.apiLiveSessionItemIdGoogleRecordingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Error>): Error => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionUpdateRecordingsLinksPost()` */
  static readonly ApiLiveSessionUpdateRecordingsLinksPostPath = '/api/live_session/update-recordings-links';

  /**
   * Update recording links for live sessions without recording link from the last two days.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionUpdateRecordingsLinksPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionUpdateRecordingsLinksPost$Response(params?: ApiLiveSessionUpdateRecordingsLinksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiLiveSessionUpdateRecordingsLinksPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Update recording links for live sessions without recording link from the last two days.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionUpdateRecordingsLinksPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionUpdateRecordingsLinksPost(params?: ApiLiveSessionUpdateRecordingsLinksPost$Params, context?: HttpContext): Observable<void> {
    return this.apiLiveSessionUpdateRecordingsLinksPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionGoogleCountParticipantsPost()` */
  static readonly ApiLiveSessionGoogleCountParticipantsPostPath = '/api/live_session/google-count-participants';

  /**
   * Update the participant count for all past live sessions without it.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionGoogleCountParticipantsPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionGoogleCountParticipantsPost$Response(params?: ApiLiveSessionGoogleCountParticipantsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiLiveSessionGoogleCountParticipantsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the participant count for all past live sessions without it.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionGoogleCountParticipantsPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionGoogleCountParticipantsPost(params?: ApiLiveSessionGoogleCountParticipantsPost$Params, context?: HttpContext): Observable<void> {
    return this.apiLiveSessionGoogleCountParticipantsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionGoogleCountParticipantsItemIdGet()` */
  static readonly ApiLiveSessionGoogleCountParticipantsItemIdGetPath = '/api/live_session/google-count-participants/{item_id}';

  /**
   * ATTENTION! This endpoint is only for internal purposes.
   * Get the meet participants count for a live session or None if a problem occurred.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionGoogleCountParticipantsItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionGoogleCountParticipantsItemIdGet$Response(params: ApiLiveSessionGoogleCountParticipantsItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionMeetParticipantsCount>> {
    return apiLiveSessionGoogleCountParticipantsItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * ATTENTION! This endpoint is only for internal purposes.
   * Get the meet participants count for a live session or None if a problem occurred.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionGoogleCountParticipantsItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionGoogleCountParticipantsItemIdGet(params: ApiLiveSessionGoogleCountParticipantsItemIdGet$Params, context?: HttpContext): Observable<LiveSessionMeetParticipantsCount> {
    return this.apiLiveSessionGoogleCountParticipantsItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveSessionMeetParticipantsCount>): LiveSessionMeetParticipantsCount => r.body)
    );
  }

  /** Path part for operation `apiLiveSessionCsvExportGet()` */
  static readonly ApiLiveSessionCsvExportGetPath = '/api/live_session/csv-export';

  /**
   * Export live sessions to a CSV file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionCsvExportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionCsvExportGet$Response(params?: ApiLiveSessionCsvExportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionExportCsvFile>> {
    return apiLiveSessionCsvExportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Export live sessions to a CSV file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionCsvExportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionCsvExportGet(params?: ApiLiveSessionCsvExportGet$Params, context?: HttpContext): Observable<LiveSessionExportCsvFile> {
    return this.apiLiveSessionCsvExportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveSessionExportCsvFile>): LiveSessionExportCsvFile => r.body)
    );
  }

}
